import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('../views/Login.vue') },
  {
    path: '/',
    component: () => import('../layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue'), meta: { title: '概览' } },
      { path: 'product', name: 'Product', component: () => import('../views/Product.vue'), meta: { title: '商品管理' } },
      { path: 'brand', name: 'Brand', component: () => import('../views/Brand.vue'), meta: { title: '品牌管理' } },
      { path: 'category', name: 'Category', component: () => import('../views/Category.vue'), meta: { title: '分类管理' } },
      { path: 'banner', name: 'Banner', component: () => import('../views/Banner.vue'), meta: { title: 'Banner管理' } },
      { path: 'home-cover', name: 'HomeCover', component: () => import('../views/HomeCover.vue'), meta: { title: '首页封面' } }
    ]
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  if (!localStorage.getItem('admin_token')) return next('/login')
  next()
})

export default router
